import React, { FC } from 'react';

import type { AnnouncementsFromBackend } from 'app/api/services/live/schedule/types';

import { Breadcrumb } from 'app/modules/Betting';

import { getBreadcrumbsByMatch } from '../utils/get-breadcrumbs-by-match-utils';
import { AnnouncementItem } from './AnnouncementItem';

import styles from '../Announcement.module.scss';

type AnnouncementTableProps = {
  matches: AnnouncementsFromBackend;
  subheaderClassName?: string;
  sportId: number;
};

const AnnouncementTable: FC<AnnouncementTableProps> = ({
  matches,
  subheaderClassName,
  sportId,
}) => {
  const breadcrumbs = getBreadcrumbsByMatch(matches[0]);

  return (
    <li>
      <Breadcrumb
        nonClickableSportsEvent
        breadcrumbs={breadcrumbs}
        sportId={sportId}
        className={subheaderClassName} />

      <ul className={styles.announcementsList}>
        {matches.map((match) => {
          return (
            <AnnouncementItem
              key={match.id}
              matchId={match.id}
              matchName={match.matchName}
              startDate={match.startDate} />
          );
        })}
      </ul>
    </li>
  );
};

export default AnnouncementTable;
